import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import * as dates from 'react-schedule-calendar/lib/utils/dates';
import InlineSeparator from '../../InlineSeparator';
import { TIME_FORMAT } from '../../../helpers/dates';
import TooltipWrapper from '../../TooltipWrapper';

const useStyles = makeStyles(theme => ({
  timeContent: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightMedium,
    [`${theme.breakpoints.up('lg')}`]: {
      marginRight: theme.spacing(2),
    },
  },
  tooltipContent: {
    height: 'auto',
    lineHeight: 1,
  },
  arrowBack: {
    marginRight: theme.spacing(1),
  },
  arrowForward: {
    marginLeft: theme.spacing(1),
  },
}));

const EventTime = ({ event, day }) => {
  const classes = useStyles();

  const rawSTA = moment(event.STA);
  const rawRegistrationStart = moment(event.start);
  const rawSTD = moment(event.STD);

  let STA = (
    <TooltipWrapper title="Arrival time">
      {rawSTA.format(TIME_FORMAT)}
    </TooltipWrapper>
  );

  let registrationStart = (
    <TooltipWrapper title="Registration start">
      {rawRegistrationStart.format(TIME_FORMAT)}
    </TooltipWrapper>
  );

  let STD = (
    <TooltipWrapper title="Departure time">
      {rawSTD.format(TIME_FORMAT)}
    </TooltipWrapper>
  );

  let timeContent = (
    <>
      {registrationStart} <InlineSeparator />
      {STA} <InlineSeparator /> {STD}
    </>
  );

  const currentDayStart = dates.startOf(day, 'day');
  const currentDayEnd = dates.endOf(day, 'day');

  if (!dates.inRange(rawSTD, currentDayStart, currentDayEnd)) {
    const arrow = (
      <TooltipWrapper title="Departure starts next day">
        <ArrowForwardOutlinedIcon className={classes.arrowForward} />
      </TooltipWrapper>
    );

    timeContent = (
      <>
        {registrationStart} <InlineSeparator /> {STA} {arrow}
      </>
    );
  }

  if (
    !dates.inRange(rawSTD, currentDayStart, currentDayEnd) &&
    !dates.inRange(rawSTA, currentDayStart, currentDayEnd)
  ) {
    const arrow = (
      <TooltipWrapper title="Arrival and departure start next day">
        <ArrowForwardOutlinedIcon className={classes.arrowForward} />
      </TooltipWrapper>
    );

    timeContent = (
      <>
        {registrationStart}
        {arrow}
      </>
    );
  }

  if (!dates.inRange(rawRegistrationStart, currentDayStart, currentDayEnd)) {
    const arrow = (
      <TooltipWrapper title="Registration starts the day before">
        <ArrowBackOutlinedIcon className={classes.arrowBack} />
      </TooltipWrapper>
    );

    timeContent = (
      <>
        {arrow} {STA} <InlineSeparator /> {STD}
      </>
    );
  }

  if (!dates.inRange(rawSTA, currentDayStart, currentDayEnd)) {
    const arrow = (
      <TooltipWrapper title="Registration and arrival start the day before">
        <ArrowBackOutlinedIcon className={classes.arrowBack} />
      </TooltipWrapper>
    );

    timeContent = (
      <>
        {arrow} {STD}
      </>
    );
  }

  return (
    <Typography className={classes.timeContent} variant="caption">
      {timeContent}
    </Typography>
  );
};

export default EventTime;
